export default __webpack_public_path__ + "static/Gop_stop-49508db1d489b7b43ac9648983869fff.png";